module.exports = __webpack_public_path__ + "images/patterns/light/StripeHorizontal.b5480173b8e7b26f24c7.svg";